import type { IconeBarcoProps } from "./types-icone-barco";
import { IconeBarcoView } from "./view-icone-barco";

/**
 * Ícone de barco por condição da obra (Figma icone-barco 713:28421: `molhado` e `seco`), 24×24 em primary/700. Tem o nome
 * da condição como nome acessível; a tela troca tamanho e cor por `className`. Usado pelo card de obra e pelo Gantt.
 */
export function IconeBarco(props: IconeBarcoProps) {
  return <IconeBarcoView {...props} />;
}

export { ICONE_BARCO_ROTULO } from "./icone-barco.constants";
export type { IconeBarcoCondicao } from "./icone-barco.constants";
export type * from "./types-icone-barco";
